/* Contact page (sections/contact-main). Chat card opens the Gorgias chat widget when it is loaded; without it the
   link falls through to the form anchor. After a submit, move focus to the success or error message. */
(() => {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-kx-chat]');
    const chat = window.GorgiasChat;
    if (!link || !chat || typeof chat.open !== 'function') return;
    e.preventDefault();
    const ready = typeof chat.init === 'function' ? chat.init() : Promise.resolve();
    Promise.resolve(ready).then(() => chat.open()).catch(() => { window.location.hash = link.hash; });
  });

  const status = document.querySelector('.contact-main [data-kx-focus]');
  if (status) status.focus({ preventScroll: false });
})();
